import { Fragment, useState } from "react"
import GsProviderConfigurationModal from "./GsProviderConfigurationModal"
import { ButtonGroup, Dropdown } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import { navigateTo } from "../../../../utils/commonFunctions"
import GroundStationService from "../../../../service/GroundStationService"
import MissionService from "../../../../service/MissionService"
import ConfirmationDialog from "../../../CommonComponents/confirmation_dialog/ConfirmationDialog"
import { InfoIcon } from "../../../simulate/scenario/svgs/Svgs"
import { AddNewEntityButton } from "../../../CommonComponents/svgs/Svgs"
import { showToastMessage } from "../../../../utils/commonFunctions"
interface GroundStationProviderProps {
    gs_providers: [];
    all_ground_stations: [];
    get_gs_providers: () => Promise<void>;
    set_loading: (data) => void;
    get_all_ground_stations: () => void;
    open_provider_config_modal: any;
    set_open_provider_config_modal: (data) => void;
    show_btn_group: any;
    set_show_btn_group: (data) => void;
    show_info_badge?: boolean
}

const GroundStationProvider: React.FC<GroundStationProviderProps> = ({ gs_providers, get_gs_providers, set_loading, get_all_ground_stations,
    open_provider_config_modal, set_open_provider_config_modal, all_ground_stations, show_btn_group, set_show_btn_group, show_info_badge }) => {
    const params = useParams();
    const navigate = useNavigate();
    const { mission_name, mission_id } = params
    const [openDeleteModal, setOpenDeleteModal] = useState<any>(false);

    const update_mission_ground_stations = (providers: any[]) => {
        let updated_mission_ground_stations: any = []
        providers?.map((provider: any) => {
            if (provider?.groundStations?.length > 0) {
                updated_mission_ground_stations = updated_mission_ground_stations?.length > 0 ? [...updated_mission_ground_stations, ...provider?.groundStations] : [...provider?.groundStations]
            }
        })
        MissionService.updateMissionStations(mission_id, updated_mission_ground_stations)?.then((res) => {
            if (res?.data) {
                showToastMessage('success', "GS Provider deleted successfully")
            }
        }).catch((err) => {
            console.error(err);
            showToastMessage('error', 'Failed to update station')
        })
    }

    const update_ground_station = async (deleted_provider: any) => {
        let provider_associated_gs = all_ground_stations?.filter((station: any) => (deleted_provider?.['groundStations'] && deleted_provider?.['groundStations']?.includes(station?.['groundStationId'])))
        let filter_providers = gs_providers?.filter((provider: any) => provider?.['uniqueId'] !== deleted_provider?.['uniqueId'])
        let updated_provider_associated_gs: any = []
        provider_associated_gs?.map((station: any) => {
            if (station?.['owner-org'] !== "System") {
                let data = {
                    ...station,
                    properties: {
                        ...station?.['properties'],
                        provider: '',
                    },
                    status: (!station?.['properties']?.['altitude'] || station?.['properties']?.['altitude'] === '') ? 'Configure' : 'Associate With Provider',
                }
                updated_provider_associated_gs = [...updated_provider_associated_gs, data]
            }
        })
        if (updated_provider_associated_gs?.length > 0) {
            try {
                const res = await GroundStationService.updateGroundStations(updated_provider_associated_gs);
                if (res?.data) {
                    // This commented code may use in future
                    // update_mission_ground_stations(filter_providers)
                    await get_all_ground_stations();
                }
            } catch (err: any) {
                console.error(err);
                showToastMessage('error', 'Something went wrong while updating ground stations');
            }
        } else {
            // This commented code may use in future
            // update_mission_ground_stations(filter_providers)
        }
    }

    const delete_provider = async (provider: any) => {
        set_loading(true);
        try {
            const res = await GroundStationService.deleteGsProvider(provider?.['uniqueId']);
            if (res) {
                await update_ground_station(provider);
                await get_gs_providers();
                showToastMessage('success', 'GS Provider deleted successfully');
            } else {
                set_loading(false);
            }
        } catch (err: any) {
            console.error(err);
            showToastMessage('error', 'Something went wrong while deleting provider');
            set_loading(false);
        }
    }

    const navigate_to_provider_details = (provider, tab_name) => {
        navigateTo(`${mission_name}/${mission_id}/station_provider/${provider?.['providerName']}/${provider?.['uniqueId']}/${tab_name}`, navigate)
    }

    const get_providers_stations = (provider) => {
        const stations = (provider?.['groundStations'] && provider?.['groundStations']?.length > 0) ? provider?.['groundStations'] : []
        return stations?.length === 0 ? 'Not Configured' : stations?.length
    }

    return (
        <Fragment>
            <div className="w-100 d-flex flex-column" onClick={() => set_show_btn_group('')}>
                {show_info_badge &&
                    <div className='px-0 py-3 gap-3'>
                        <div className="info-msg-div py-2 px-3 justify-content-start align-items-start">
                            <InfoIcon />
                            <span className='info-msg-text'>
                                Associate standalone ground stations with a ground station provider to use them in scenario simulations.
                            </span>
                        </div>

                    </div>
                }
                <span className="fs-14 mb-3">Ground Station Providers</span>
                <div className="w-100 d-flex align-items-start flex-wrap gap-3">
                    {gs_providers?.length > 0 && gs_providers?.map((provider: any, index: number) => (
                        <div className="mission-card d-flex flex-column justify-content-between" key={index} onClick={() => navigate_to_provider_details(provider, 'Configuration')}>
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <div className="d-flex align-items-center gap-1 w-90">
                                    {provider?.['providerName'] === 'LeafSpace' && <img src={require('../../../../assets/images/svgs/gs/leaf_space_provider.svg').default} height={30} width={30} alt='provider' />}
                                    {(provider?.['providerName'] !== 'LeafSpace' && provider?.['providerName'] !== 'Atlas') && <img src={require('../../../../assets/images/svgs/gs/custom_gs_provider.svg').default} height={30} width={30} alt='provider' />}
                                    <span className="fs-20 color-atmos text-truncate w-90" title={provider?.['providerName']}>{provider?.['providerName']}</span>
                                </div>
                                <ButtonGroup size="sm" className="flex-nowrap" onClick={(e) => e.stopPropagation()}>
                                    <div className="btn-list more-button">
                                        <Dropdown drop="end" show={show_btn_group === provider?.['uniqueId']}>
                                            <Dropdown.Toggle size="sm" variant="transparent" onClick={() => { set_show_btn_group(show_btn_group === provider?.['uniqueId'] ? '' : provider?.['uniqueId']) }}>
                                                <i className="fe fe-more-vertical fs-20"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item eventKey="1"
                                                    onClick={() => {
                                                        set_open_provider_config_modal({
                                                            mode: 'Update',
                                                            type: provider?.['IsAntarisGsiteProvider'] ? 'Custom' : 'Provider',
                                                            data: provider
                                                        })
                                                        set_show_btn_group('')
                                                    }}>
                                                    Edit
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="2"
                                                    onClick={() => {
                                                        setOpenDeleteModal(provider)
                                                        set_show_btn_group('')
                                                    }}>
                                                    Delete
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </ButtonGroup>
                            </div>
                            <div className="d-flex flex-column">
                                <span className="w-95 text-truncate fs-14">{get_providers_stations(provider)}</span>
                                <span className="color_history fs-12">Ground Stations </span>
                            </div>
                            <div className="d-flex flex-column gap-3">
                                <span className="border-bottom"></span>
                                <div className="d-flex align-items-ceter justify-content-between">
                                    <div className="d-flex gap-2 align-items-center">
                                        <span className="fs-12 color-history">{provider?.['status'] === 'Configured' ? 'Configuration Completed' : 'Configuration Pending'}</span>
                                    </div>
                                    <button className="p-0 ps-3 border-0 w-auto d-flex align-items-center fs-12 gap-1 bg-transparent color-atmos"
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            set_show_btn_group('')
                                            if (provider?.['nextConfigStep'] === 'Add Ground Station' || provider?.['nextConfigStep'] === 'Configure Ground Station') {
                                                navigate_to_provider_details(provider, 'Station')
                                            } else if (provider?.['nextConfigStep'] === 'Configure MQTT Topics') {
                                                navigate_to_provider_details(provider, 'MQTT_Topic')
                                            } else if (provider?.['nextConfigStep'] === 'Configure Provider') {
                                                set_open_provider_config_modal({
                                                    mode: 'Update',
                                                    data: provider
                                                })
                                            } else {
                                                navigate_to_provider_details(provider, 'Configuration')
                                            }
                                        }}
                                    >
                                        {provider?.['nextConfigStep']}
                                        {provider?.['nextConfigStep'] !== '' && <i className="fe fe-chevron-right fs-16"></i>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="add_gs_provider"
                        onClick={() => {
                            set_show_btn_group('')
                            set_open_provider_config_modal({
                                mode: 'Create'
                            })
                        }}>
                        <div className="d-flex mt-2 align-items-center gap-2">
                            <AddNewEntityButton />
                            <span className="gsEmptyStateText">Add GS Provider</span>
                        </div>
                    </div>
                </div>
            </div>

            {open_provider_config_modal &&
                <GsProviderConfigurationModal
                    close={async (skipRefresh?: boolean) => {
                        if (skipRefresh !== true) await get_gs_providers();
                        set_open_provider_config_modal(false);
                    }}
                    get_gs_providers={get_gs_providers}
                    openModal={open_provider_config_modal}
                    all_providers={gs_providers}
                    all_ground_stations={all_ground_stations}
                />
            }

            <ConfirmationDialog
                type='delete'
                open={openDeleteModal ? true : false}
                title={`Delete GS Provider?`}
                description={`Deleting ${openDeleteModal?.['providerName']} will permanently remove it from the database, and it cannot be restored once deleted.`}
                onCancel={() => setOpenDeleteModal(false)}
                onConfirm={() => {
                    delete_provider(openDeleteModal)
                    setOpenDeleteModal(false);
                }}
                confirm_button_text={`Delete`}
            />

        </Fragment>
    )
}

export default GroundStationProvider